module.exports = __webpack_public_path__ + "static/media/form-example.7a908894.jpg";